// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电厂热力设备及运行",
      "tec": "王树群",
      "week": "6-17周",
      "add": "教学楼B座224自控"
    },
    {
      "sub": "电子技术",
      "tec": "梁岱立",
      "week": "6-17周",
      "add": "教学楼C座210教务"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "高雪",
      "week": "6-17周",
      "add": "教学楼A座426机械"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "检测技术及仪表",
      "tec": "韩希昌",
      "week": "6-17周",
      "add": "教学楼B座223自控"
    },
    {
      "sub": "基础英语（一）",
      "tec": "于静",
      "week": "6-17周",
      "add": "教学楼B座120自控"
    },
    {
      "sub": "就业创业指导",
      "tec": "尹思佳",
      "week": "6-10周",
      "add": "教学楼C座215教务"
    },
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "6-9周",
      "add": "教学楼C座213教务"
    },
    0
  ],
  "3": [
    {
      "sub": "电子技术",
      "tec": "梁岱立",
      "week": "6-17周",
      "add": "教学楼C座212教务"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "陈钢",
      "week": "6-17周",
      "add": "教学楼C座306教务"
    },
    0,
    {
      "sub": "军事理论",
      "tec": "王春林",
      "week": "6-14周",
      "add": "教学楼C座307教务"
    },
    0
  ],
  "4": [
    {
      "sub": "基础英语（一）",
      "tec": "于静",
      "week": "7,9,11,13,15,17周",
      "add": "教学楼B座120自控"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "高雪",
      "week": "6-17周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "电厂热力设备及运行",
      "tec": "王树群",
      "week": "6-17周",
      "add": "实训楼F座202自控"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学基础（一）",
      "tec": "陈钢",
      "week": "6-17双周",
      "add": "教学楼C座306教务"
    },
    {
      "sub": "检测技术及仪表",
      "tec": "韩希昌",
      "week": "6-17周",
      "add": "教学楼B座218自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
